import {
    Container
} from './styles'

import {
    Title
} from '../../components'
import { useHistory } from 'react-router-dom'

export default function Tronco(){

    const items = [
        {
            text: "Tomografia Computadorizada Multislice do Tórax",
            url: "/torax"
        },
        {
            text: "Tomografia Computadorizada Multislice do Tórax em Alta Resolução",
            url: "/toraxAR"
        },
        {
            text: "Tomografia Computadorizada Multislice Abdômen Superior com Contraste I.V.",
            url: "/abdomenContraste"
        },
        {
            text: "Tomografia Computadorizada Multislice da Pelve com Contraste I.V.",
            url: "/pelve"
        },
        {
            text: "Tomografia Computadorizada Multislice Abdômen Total com Contraste I.V.",
            url: "/abdomen"
        },
        {
            text: "Tomografia Computadorizada Multislice Rins e vias urinárias / Urotomografia Sem Contraste I.V.",
            url: "/rins"
        },
        {
            text: "Tomografia Computadorizada Multislice Rins e vias urinarias Urotomografia com Contraste I.V. ",
            url: "/rinsContraste"
        },
    ]

    const history = useHistory()
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Tronco</Title>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-10">
                    {
                        items.map(item => (
                            <button
                                key={item.url}
                                className="btn btn-info btn-block my-4"
                                onClick={
                                    () => history.push(`/tronco${ item.url }`)
                                }
                            >{ item.text }</button>
                        ))
                    }
                </div>
            </div>
        </Container>
    )
}